export * from './tab-nav-bar';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/tabs/tab-nav-bar/index.js
// module id = ../../../material/tabs/tab-nav-bar/index.js
// module chunks = 3